export default function Privacy() {
  return (
    <div style={{ maxWidth: 900, margin: "40px auto", padding: 20 }}>
      <h1>Privacy Policy</h1>

      <p>
        This privacy policy sets out how ORIVON TECHNOLOGIES uses and protects
        any information that you provide when you use this website.
      </p>

      <p>
        We may collect the following information:
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Contact details</li>
          <li>Preferences and interests</li>
        </ul>
      </p>

      <h3>How we use the information</h3>
      <ul>
        <li>Internal record keeping</li>
        <li>Improving products and services</li>
        <li>Sending promotional emails (if opted in)</li>
        <li>Market research purposes</li>
        <li>Customizing the website experience</li>
      </ul>

      <h3>Security</h3>
      <p>
        We are committed to ensuring that your information is secure. Suitable
        safeguards are in place to prevent unauthorized access.
      </p>

      <h3>Cookies</h3>
      <p>
        Cookies help analyze web traffic and improve user experience. You may
        choose to accept or decline cookies through your browser settings.
      </p>

      <h3>Controlling your personal information</h3>
      <p>
        You may restrict the use of your personal data by contacting us at
        <strong> contact@orivontechnologies.com</strong>.
      </p>

      <p>
        Address: Thane, Maharashtra – 400607  
      </p>
    </div>
  );
}
